export default __webpack_public_path__ + "static/4-b687a7e769c2803f55e3b18ee45badc4.jpg";